/** @format */

import { TStore } from '../../redux/helpers/createStore';
import { TReducerBooking } from '../booking/selectors';
import { TListType } from '../filters/declarations';
import { TRoom } from '../room/declarations';

export interface TReducerGeneral {
  availabilityArray: Array<TReducerBooking['availability']>;
  GTMListType: Array<TListType>;
  currentPage?: string;
  locale?: string;
  contentfulData?: any;
  isLoading?: true;
  isLoadingConditions?: true;
  isVisibleBanner: boolean;
  isViewMap?: boolean;
}

export const selectorAvailabilityArray = (store: TStore) => store.general.availabilityArray;
export const selectorAvailabilityRoom = (store: TStore, roomCode: TRoom['code']) => {
  const availabilityArray = store.general.availabilityArray;
  const availabilityFound = availabilityArray.find(availability => availability && availability.bedCode === roomCode);
  return availabilityFound;
};

export const selectorGeneral = (store: TStore) => store.general;

export const selectorCurrentPage = (store: TStore) => store.general.currentPage;

export const selectorLocale = (store: TStore) => store.general.locale;

export const selectorViewMap = (store: TStore) => store.general.isViewMap;

export const selectorViewWhatYouWillGetIntro = (store: TStore) => {
  const pageData = store.general.contentfulData?.viewWhatYouWillGet?.allContentfulWhatYouWillGet.edges;
  if (!pageData) return null;
  const dataIntro = pageData.find((el: any) => el.node.name === 'Intro');
  const intro = dataIntro.node;
  return intro;
};

export const selectorViewBrandingIntro = (store: TStore) => {
  const pageData = store.general.contentfulData?.viewBranding?.allContentfulBranding.edges;
  if (!pageData) return null;
  const dataIntro = pageData.find((el: any) => el.node.name === 'IntroBranding');
  const intro = dataIntro.node;
  return intro;
};

export const selectorViewBrandingCards = (store: TStore) => {
  const pageData = store.general.contentfulData?.viewBranding?.allContentfulBranding.edges;
  if (!pageData) return null;
  const dataCards = pageData.find((el: any) => el.node.name === 'CardsBranding');
  const cards = dataCards.node;
  const images = cards.media.map((el: any) => ({
    img: el.gatsbyImageData.images.fallback.src,
    link: el.description,
    title: el.title,
  }));
  return images;
};

export const selectorViewBrandingSlider = (store: TStore) => {
  const pageData = store.general.contentfulData?.viewBranding?.allContentfulBranding.edges;
  if (!pageData) return null;
  const dataSlider = pageData.find((el: any) => el.node.name === 'SliderBranding');
  const slider = dataSlider.node;
  const mediaSlider = slider.media.map((el: any) => el.gatsbyImageData.images.fallback.src);
  const formattedSlider = slider.listJson?.map((el: any, index: number) => ({
    title: el.title,
    subtitle: el.subTitle,
    description: el.description,
    category: el.cat,
    img: mediaSlider[index],
    index,
  }));
  return formattedSlider;
};

export const selectorViewBrandingServices = (store: TStore) => {
  const pageData = store.general.contentfulData?.viewBranding?.allContentfulBranding.edges;
  if (!pageData) return null;
  const dataServices = pageData.find((el: any) => el.node.name === 'ServiceBranding');
  const services = dataServices.node;
  const titleServicesComponent = services.title?.title;
  const mediaSlider = services.media.map((el: any) => el.gatsbyImageData.images.fallback.src);
  const formattedServices = services.list?.map((el: any, index: number) => ({ label: el, img: mediaSlider[index] }));

  return { title: titleServicesComponent, services: formattedServices };
};

export const selectorViewBrandingPartners = (store: TStore) => {
  const pageData = store.general.contentfulData?.viewBranding?.allContentfulBranding.edges;
  if (!pageData) return null;
  const partners = pageData.find((el: any) => el.node.name === 'PartnersBranding').node;
  const titlePartnersComponent: string = partners.title?.title;
  const listCountryPartners: string[] = partners.listDescription;
  const logoSponsors = partners.media.map((el: any) => ({
    img: el.gatsbyImageData.images.fallback.src,
    country: el.description,
  }));

  return { title: titlePartnersComponent, sponsorCountries: listCountryPartners, logoList: logoSponsors };
};

export const selectorViewBrandingComments = (store: TStore) => {
  const pageData = store.general.contentfulData?.viewBranding?.allContentfulBranding.edges;
  if (!pageData) return null;
  const comments = pageData.find((el: any) => el.node.name === 'CommentsBranding').node;
  const titleCommentsComponent = comments.title?.title;
  const mediaComments = comments.media.map((el: any) => el.gatsbyImageData.images.fallback.src);
  const commentsBody = comments.listJson?.map((comment: any) => ({
    title: comment.title,
    auth: comment.auth,
    descr: comment.descr,
  }));

  return { title: titleCommentsComponent, imageQuote: mediaComments, commentsList: commentsBody };
};

export const selectorIsLoadingSearch = (store: TStore) => store.general?.isLoading;

export const selectorIsVisibleBanner = (store: TStore) => store.general.isVisibleBanner;

export const selectorGtmListType = (store: TStore) =>
  store.general.GTMListType?.[store.general.GTMListType?.length - 1];
